import { createSlice } from "@reduxjs/toolkit";
import userDetails from "@custom/rtk-apis/user/userDetails";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const userDetailSlice = createSlice({
  name: "patientListSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userDetails.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(userDetails.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(userDetails.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default userDetailSlice.reducer;
